import { 
    GET_SUMMARY_ACCUMULATION,
    GET_SUMMARY_BAD_USER,
    GET_SUMMARY_GRAPH,
    GET_SUMMARY_REVIEW,
    GET_SUMMARY_TOTAL_POST,
    KM_CHANGE_TW_YEAR,
 } from "shared/constants/ActionTypes";

const changeTWYear={
    tw:null,
    year:null,
    status:false
}

const initialState = {
    dataSummaryAccumulation: null,
    dataSummaryGraph: null,
    dataSummaryReview: null,
    dataSummaryTotalPost:null,
    dataBadUser:null,
    changeTWYear:changeTWYear
};

const getKMAdminSummaryReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_SUMMARY_ACCUMULATION:
            return {
                ...state,
                dataSummaryAccumulation:action.payload
            }
        case GET_SUMMARY_GRAPH:
            return {
                ...state,
                dataSummaryGraph:action.payload
            }
        case GET_SUMMARY_REVIEW:
            return {
                ...state,
                dataSummaryReview:action.payload
            }
        case GET_SUMMARY_TOTAL_POST:
            return {
                ...state,
                dataSummaryTotalPost:action.payload
            }
        case GET_SUMMARY_BAD_USER:
            return {
                ...state,
                dataBadUser:action.payload
            }
        case KM_CHANGE_TW_YEAR:
            return {
                ...state,
                changeTWYear:action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default getKMAdminSummaryReducer;